<template>
  <div class="student-form">
    <h5>{{ userType === '0' ? 'Dine opplysninger' : 'Elevens opplysninger' }}</h5>
    
    <div class="form-group">
      <label>{{ $t("Mobilnummer") }}</label>
      <input 
        :value="student.mobile"
        @input="updateField('mobile', $event.target.value)"
        type="text" 
        class="form-control input" 
        :readonly="userType === '0'"
      />
    </div>

    <div class="form-group">
      <label>{{ $t("Fornavn") }}</label>
      <input 
        :value="student.firstName"
        @input="updateField('firstName', $event.target.value)"
        type="text" 
        class="form-control input" 
        :readonly="userType === '0'"
      />
    </div>

    <div class="form-group">
      <label>{{ $t("Etternavn") }}</label>
      <input 
        :value="student.lastName"
        @input="updateField('lastName', $event.target.value)"
        type="text" 
        class="form-control input" 
        :readonly="userType === '0'"
      />
    </div>

    <div class="form-group">
      <label>{{ $t("Fødselsdato") }}</label>
      <input 
        :value="student.birthdate"
        @input="updateField('birthdate', $event.target.value)"
        type="text" 
        placeholder="dd.mm.åååå"
        class="form-control input" 
        :readonly="userType === '0'"
      />
    </div>

    <div class="form-group">
      <label>{{ $t("E-postadresse") }}</label>
      <input 
        :value="student.email"
        @input="updateField('email', $event.target.value)"
        type="email" 
        class="form-control input"
      />
    </div>

    <div class="form-group">
      <label>{{ $t("Hvilken opplæring ønsker du å ta?") }}</label>
      <select :value="student.classId"
        @change="updateField('classId', $event.target.value)"
        class="form-control input">
        <option value="">- {{ $t("Velg opplæring") }} -</option>
        <option v-for="classItem in classes" :key="classItem.class_id" :value="classItem.class_id">
          {{ classItem.logic_name }} ({{classItem.short_name}})
        </option>
      </select>
    </div>
  </div>
</template>

<script setup>
import wizardStore from '../../state/vippsWizardStore.js'

const props = defineProps({
  student: Object,
  userType: String,
  classes: Array
})

const updateField = (field, value) => {
  wizardStore.state.student.value[field] = value
  
  // Check contact requirement when mobile or birthdate changes
  if (field === 'mobile' || field === 'birthdate') {
    wizardStore.checkContactRequirement()
  }
}
</script>
